const ThreePerks = () => {

    return(
        <div className="text-center container container-fluid" style={{margin: '4% auto'}}>
            <div className="row align-items-start">
                <div className="col-lg-4 col-md-4 col-sm-12" style={{margin: '5% auto'}}>
                    <h3 style={{color: '#2E62ED'}}>Easy to Integrate</h3>
                    <p style={{fontSize: '1.1rem'}}>Just Configure on Beyond Static and add a function to the JS of the code. Integration has never been this hassle-free</p>
                </div>
                <div className="col-lg-4 col-md-4 col-sm-12" style={{margin: '5% auto'}}>
                    <h3 style={{color: '#2E62ED'}}>Multiple Projects</h3>
                    <p style={{fontSize: '1.1rem'}}>Set up and track multiple website projects with incoming form data. Interactive dashboard to manage like a boss</p>
                </div>
                <div className="col-lg-4 col-md-4 col-sm-12" style={{margin: '5% auto'}}>
                    <h3 style={{color: '#2E62ED'}}>Open Source</h3>
                    <p style={{fontSize: '1.1rem'}}>See what you're getting into and help contribute and grow the Beyond Static Community. New features coming soon</p>
                </div>
            </div>
        </div>
    )

}

export default ThreePerks